<template>
  <router-link :to="{name: 'quiz_details_custom', params: {id: quiz_data.id, title: quiz_data.name}}" style="text-decoration: none; width: 100%">
    <div class="quiz-block" >

      <div class="quiz-image">
        <img :class="[quiz_data.is_live?'': 'brightness']" v-bind:src="quiz_data.banner_url" alt="quiz" class="img-fluid">
      </div>
      <div class="quiz-detail" style="justify-content: center;">
        <!-- <div class="quiz-name">
          <span class="quiz-name">{{quiz_data.name}}</span>
          <p v-if="quiz_data.currency_label == 'Cash'">Total Prize: <img :src="quiz_data.currency_icon" width="12px" alt="currency"> ₹{{quiz_data.prize}}</p>
          <p v-else>Total Prize: <img :src="quiz_data.currency_icon" width="12px" alt="currency"> {{quiz_data.prize}} {{quiz_data.currency_label}}</p>
        </div> -->
        <div class="quiz-play">
<!--          <div style="padding-top: 0.4rem">
            <h3 class="h3">{{quiz_data.name}}</h3>
            <span class="total-prize">Total: {{quiz_data.prize}}</span>
          </div>-->
          <div class="play-time-details">
            <div
              :class="[quiz_data.is_live ? 'quiz-end' : '', 'timer']"
            >
              <span>{{quiz_data.is_live ? "Ends In:- "+ time_left : 'Starts In:- ' + time_left }}</span>
            </div>
            <div style="margin-top: 10px; padding-bottom: 8px">
              <span class="btn btn-pink">Play <img v-if="quiz_data.is_live" src="@/assets/play.svg" alt="play"
                                                   class="img-fluid"></span>
            </div>

          </div>

        </div>
      </div>
    </div>
  </router-link>
</template>
<script>
import moment from "moment"
export default {
  name: 'quiz-list-card',
  props: {
    quiz_data: Object
  },
  data() {
    return {
      time_left: '',
    }
  },
  methods: {
    formatISODateString(dateStr) {
      var date = new Date(dateStr);
      var month = date.toLocaleString('default', { month: 'short' });
      var year = date.getFullYear();
      var hour = date.getHours();
      var min = date.getMinutes();
      var sec = date.getSeconds();
      var dt = date.getDate();

      if (dt < 10) {
        dt = '0' + dt;
      }
      if (hour < 10) {
        hour = '0' + hour;
      }
      if (min < 10) {
        min = '0' + min;
      }
      if (sec < 10) {
        sec = '0' + sec;
      }

     // return `${dt} ${month} ${year} ${hour}:${min}:${sec}`;
      return `${hour}h:${min}m:${sec}s`;
    },
    getImgUrl(pic) {
      return require('@/assets/'+pic)
    },
    async showTime(data) {
        let dateStr = '';
        let timeleft = '';
        if(data.is_live) {
          dateStr = data.ends_at;
        } else {
          dateStr = data.starts_at;
        }
        var d = new Date();
        var d2 = new Date(dateStr);
        var milSec = d2-d;
        while(milSec>0){
          var d3 = new Date(milSec);
          let nrDays = (Math.floor(d3/1000/60/60/24));
          let nrHours = (Math.floor(d3/1000/60/60))%24;
          let nrMin = (Math.floor(d3/1000/60))%60;
          let nrSec = (Math.floor(d3/1000))%60;

          nrHours = nrHours<10?'0'+nrHours:nrHours;
          nrMin = nrMin<10?'0'+nrMin:nrMin;
          nrSec = nrSec<10?'0'+nrSec:nrSec;
          if(nrDays!==0){
            nrDays = nrDays<10?'0'+nrDays+'d:':nrDays+'d:';
          } else {
            nrDays = '';
          }
          timeleft = `${nrDays}${nrHours}h:${nrMin}m:${nrSec}s`;
          timeleft.replace("-","");
          milSec -= 1000
          this.time_left = timeleft;
          await this.sleep(1000);
        }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  },
  created(){
    this.showTime(this.quiz_data)
  },
  computed: {
    time: ()=> {
      return  this.time_left
    },
  },
  mounted: function(){
    setInterval(() => {
      //this.date = moment(this.date.subtract(1, 'seconds'))
    }, 1000);
  }
}
</script>
<style scoped>
  @import '../assets/quiz-styles/quiz-styles.css';


  .brightness {
    filter: brightness(0.75);
    opacity: 0.65;
  }
  .quiz-play {
    display: flex;
    justify-content: center;
    padding: 0.25rem;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;

  }
  .h3 {
    color: #736C6C;
    font-size: 20px;
    margin-block-start: 0 !important;
    margin-block-end:  0 !important;
  }
  .total-prize {
    margin-top: 5px;
    color: #736C6C;
    font-size: 13px;
    font-weight: lighter;
  }

  .play-time-details {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/quiz-list-card.vue